module.exports = __webpack_public_path__ + "img/sv13.bfc52f03.svg";